import { render, staticRenderFns } from "./CapacityTypeDialog.vue?vue&type=template&id=cbc9a120"
import script from "./CapacityTypeDialog.vue?vue&type=script&lang=ts"
export * from "./CapacityTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports